import { FieldErrors } from './FieldErrors';

import { useFieldContext } from '.';

interface Props {
  autoFocus?: boolean;
  label: string;
  noLabel?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  required?: boolean;
  value?: string;
}

export function MonsterTextAreaField({
  autoFocus,
  label,
  noLabel,
  onChange,
  placeholder,
  required = true,
  value
}: Props) {
  const field = useFieldContext<string>();

  return (
    <div>
      <label htmlFor={field.name} className={`block leading-6 font-medium ${noLabel ? 'sr-only' : ''}`}>
        {label}
      </label>
      <div className='mt-2'>
        <textarea
          autoFocus={autoFocus}
          required={required}
          value={value ? value : field.state.value}
          onChange={onChange ? onChange : (e) => field.handleChange(e.target.value)}
          name={field.name}
          id={field.name}
          className='ring-monsterPurple focus:ring-monsterGreen text-siteBackground nice-focus block w-full rounded-lg border-0 bg-white px-3 py-2 ring-2 transition-all duration-200 ease-in-out outline-none ring-inset placeholder:text-gray-400 focus:ring-inset'
          placeholder={placeholder}
        />
      </div>
      <FieldErrors meta={field.state.meta} />
    </div>
  );
}
